<div class="workorder-card" *ngIf="canOpenPopup">
    <h1 mat-dialog-title class="workorder-title">Add Workorder</h1>
    <mat-dialog-content class="mat-typography">
        <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Programs</mat-label>
            <mat-select [(ngModel)]="selectedQaWorkOrder">
                <mat-option *ngFor="let program of programs" [value]="program.ProgramId"
                    style="font-size: 11px;">{{program.ProgramName}}</mat-option>
            </mat-select>
        </mat-form-field>

    </mat-dialog-content>
    <mat-dialog-actions align="flex-start">
        <button mat-button class="workorder-dialog-button" (click)='openQaWorkOrder()'>Create Workorder</button>
    </mat-dialog-actions>
</div>